// extracted by mini-css-extract-plugin
var _1 = "Mention-module__animatedBackground--j5Pp6";
var _2 = "Mention-module__container--Z_xjH";
var _3 = "Mention-module__content--mcma0";
export { _1 as "animatedBackground", _2 as "container", _3 as "content" }
